export default __webpack_public_path__ + "static/media/Melissa_Rohlfs_AHV_In_Moms_We_Trust.526e5524.jpg";